module.exports = __webpack_public_path__ + "static/media/campfire.da81a41f.svg";